// extracted by mini-css-extract-plugin
export default {"labelWrapper":"FieldVideoLinkImport_labelWrapper__Kkhak"};